import {useState} from 'react';
import {useBetween} from 'use-between';

const _useAccordionState = () => {
  const [isOpen, setIsOpen] = useState('');

  const handleAccordionState = (accordionId: string) => {
    if (accordionId === isOpen) {
      setIsOpen('');
    } else {
      setIsOpen(accordionId);
    }
  };

  return {
    handleAccordionState,
    isOpen,
    setIsOpen,
  };
};

export const useAccordionState = () => useBetween(_useAccordionState);
